import { useRouter } from "next/router";

import { useStoreContext } from "../../contexts/StoreDataContext";
import Footer from "../Footer/Footer";
import StaticInfoBanner from "../Infobanner/StaticInfoBanner";
import CollectionHome from "./CollectionHome";
import FeaturedHome from "./FeaturedHome";
import { ScrollProvider } from "./ScrollPositionProvider";

export const MainHome = ({ store, theme, hideHeroMedia }) => {
  const router = useRouter();
  const context = useStoreContext();
  const isProplanActive = context?.isProplanActive;

  const homeActive = isProplanActive && !!store?.homePageEnabled && !hideHeroMedia;
  const hasBanner = store?.storeBanner?.text ?? false;

  const updateHomeActive = () => {
    router.push("/shop");
  };

  return (
    <main className="w-screen max-w-app flex-auto bg-background transition-[max-height] duration-200">
      {homeActive ? (
        <FeaturedHome
          theme={theme}
          store={store}
          updateHomeActive={updateHomeActive}
          heroMedia={store?.homePage?.heroMedia.url}
          heroMediaImages={store?.homePage?.heroMediaImages}
          heroMediaType={store?.homePage?.heroMediaType}
          heroTitle={store.homePage.heroTitle ? store.homePage.heroTitle : store.storeName}
        />
      ) : (
        <ScrollProvider>
          {isProplanActive && hasBanner && <StaticInfoBanner text={store?.storeBanner?.text} />}
          <CollectionHome store={store} theme={theme} hasBanner={hasBanner} />
        </ScrollProvider>
      )}

      <Footer />
    </main>
  );
};
